import { __assign } from "tslib";
import initialReducerState from './initialReducerState';
export default function reducer(state, action) {
    var responses = {
        start: function () { return initialReducerState; },
        resolve: function () { return (__assign(__assign({}, state), { data: action.payload, loading: false })); },
        reject: function () { return (__assign(__assign({}, state), { error: action.payload, loading: false })); }
    };
    return responses[action.type]();
}
//# sourceMappingURL=reducer.js.map